<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Documentação Necessária';    
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>    
<div class="container">
	<p>Confira abaixo os documentos necessários para locação, de acordo com seu perfil.</p>
	<hr>
	<div class="box-itens-icon grid grid-size--1 grid-size-sm--1">

		<div class="item">			
			<div class="infos">
				<h2 class="title color-primary">Locatário(a) - Pessoa Física</h2>
				<ul>
					<li>• Cópia da carteira de identidade e do CPF (locatário e cônjuge, se houver);</li>
					<li>• Cópia do comprovante de residência;</li>
					<li>• Cópia do comprovante de renda líquida <b>(três vezes o valor do aluguel e taxas)</b>;</li>
					<li>• Cópia da carteira de trabalho atualizada <b>(exceto para aposentados e/ou funcionários públicos)</b>;</li>
					<li>• Cópia da declaração do imposto de renda do ano anterior;</li>
					<li>• Cópia da declaração de renda <b>(se for autônomo assinada pelo contador)</b>;</li>
					<li>• Se casado(a), os documentos apresentados devem ser do casal, e deve ser anexada a cópia da Certidão de Casamento;</li>
					<li>• Ficha Cadastral devidamente preenchida e assinada - <a href="/fichas-cadastrais">Clique aqui para acessar</a>;</li>
				</ul>
			</div>
		</div>

		<div class="item">			
			<div class="infos">
				<h2 class="title color-primary">Locatário(a) - Pessoa Jurídica</h2>
				<ul>
					<li>• Cópia do contrato social ou estatuto;</li>
					<li>• Cópia da última alteração;</li>
					<li>• Cópia do último balanço geral;</li>
					<li>• Cópia da carteira de identidade e do CPF;</li>
					<li>• Cópia da relação de bens imóveis da empresa ou diretores;</li>
					<li>• Ficha Cadastral devidamente preenchida e assinada - <a href="/fichas-cadastrais">Clique aqui para acessar</a>;</li>
				</ul>
			</div>
		</div>

		<div class="item">			
			<div class="infos">
				<h2 class="title color-primary">Fiador(a) - Pessoa Física</h2>
				<ul>
					<li>• Cópia da carteira de identidade e do CPF (fiador e cônjuge, se houver);</li>
					<li>• Cópia do comprovante de residência;</li>
					<li>• Cópia do comprovante de renda líquida <b>(três vezes o valor do aluguel e taxas)</b>;</li>
					<li>• Cópia da carteira de trabalho atualizada <b>(exceto para aposentados e/ou funcionários públicos)</b>;</li>
					<li>• Cópia da declaração do imposto de renda do ano anterior;</li>
					<li>• Cópia da declaração de renda <b>(se for autônomo assinada pelo contador)</b>;</li>
					<li>• Para <b>locação de imóveis residenciais</b>: certidões atualizadas do Registro Geral de Imóveis, de 01 imóvel quitado <b>(exceto terrenos e vagas de estacionamento)</b> em Porto Alegre. Se forem de fora de Porto Alegre, serão analisados, caso a caso.</li>
					<li>• Para <b>locação de imóveis comerciais</b>: certidões atualizadas do Registro Geral de Imóveis, de 02 imóveis quitados <b>(exceto terrenos e vagas de estacionamento)</b> em Porto Alegre. Se forem de fora de Porto Alegre, serão analisados, caso a caso.</li>
					<li>• Se casado(a), os documentos apresentados devem ser do casal, e deve ser anexada a cópia da Certidão de Casamento;</li>
					<li>• Ficha Cadastral devidamente preenchida e assinada - <a href="/fichas-cadastrais">Clique aqui para acessar</a>;</li>
				</ul>
			</div>
		</div>

		<div class="item">			
			<div class="infos">
				<h2 class="title color-primary">Atenção</h2>
				<ul>
					<li>• Todas as certidões apresentadas <b>(Registro Geral de Imóveis e Foro)</b> devem ser originais;</li>
					<li>• Todas as cópias exigidas deverão vir sempre acompanhadas das originais;</li>
					<li>• Não aceitamos fiadores profissionais (fiança comprada);</li>
					<li>• Os imóveis apresentados para fiança, devem ser livres de ônus ou hipoteca, e registrados em Porto Alegre. Se forem de fora de Porto Alegre, serão analisados, caso a caso;</li>
					<li>• A preferência de locação somente será dada no momento da entrega das fichas cadastrais, devidamente preenchidas e assinadas, acompanhada da completa documentação exigida;</li>
					<li>• Em hipótese alguma terá o candidato direito a indenização pelas despesas decorrentes do cadastro;</li>
				</ul>
			</div>
		</div>

	</div>
	<br />

	<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<div class="button text-center mt-40">
		<a href="/garantias-locaticias" use:link replace title="Confira as garantias locatícias" class="btn btn-secondary">Confira as Garantias Locatícias <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> </a>
	</div>

</div>